import React from "react";
import { Button, Stack, Typography } from "@mui/material";

import { CoreNetworkMemberAvatar, PagedTable, SectionCard, StatusChip, formatCurrency, formatDateTime, safeArray } from "../coreNetworkUiShared";

export default function CoreNetworkAssignmentPanel({ assignments = [], canViewPayment = false, onPreviewTalent = null }) {
  const getLatestPayout = (row) => {
    const payouts = safeArray(row.payouts);
    if (!payouts.length) return null;
    return payouts
      .slice()
      .sort((left, right) => new Date(right.updatedAt || right.createdAt) - new Date(left.updatedAt || left.createdAt))[0];
  };

  const columns = [
    {
      key: "memberId",
      label: "Member",
      render: (row) => (
        <Stack direction="row" spacing={1.25} alignItems="center">
          <CoreNetworkMemberAvatar member={row.member} size={34} />
          <Stack spacing={0.5}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {row.member?.displayName || row.memberId || "-"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {row.membership?.role || "-"}
            </Typography>
          </Stack>
        </Stack>
      ),
    },
    { key: "status", label: "Status", render: (row) => <StatusChip value={row.status} /> },
    { key: "providerStatus", label: "Provider", render: (row) => row.providerStatus ? <StatusChip value={row.providerStatus} /> : "-" },
    ...(canViewPayment
      ? [
          { key: "feeAmount", label: "Fee", render: (row) => formatCurrency(row.feeAmount, row.feeCurrency || "CAD") },
          {
            key: "payoutStatus",
            label: "Payout",
            render: (row) => {
              const payout = getLatestPayout(row);
              return payout ? <StatusChip value={payout.status} /> : "-";
            },
          },
        ]
      : []),
    { key: "acceptedAt", label: "Accepted", render: (row) => formatDateTime(row.acceptedAt) },
    { key: "startedAt", label: "Started", render: (row) => formatDateTime(row.startedAt) },
    { key: "completedAt", label: "Completed", render: (row) => formatDateTime(row.completedAt) },
    ...(onPreviewTalent ? [{
      key: "talentPreview",
      label: "Talent view",
      render: (row) => row.memberId ? (
        <Button size="small" variant="outlined" onClick={() => onPreviewTalent(row.id)}>
          View as Talent
        </Button>
      ) : "-",
    }] : []),
  ];

  return (
    <SectionCard title="Assignments" subtitle="Assigned providers and current execution state.">
      <PagedTable
        rows={safeArray(assignments)}
        columns={columns}
        emptyTitle="No assignments yet"
        emptyDescription="Assignments appear once a provider is chosen or an offer is accepted."
      />
    </SectionCard>
  );
}
